import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { EmployeeService } from "../../services/employees.service";
import EmployeeTable from "../../components/employees/EmployeeTable";
import EmployeeFormModal from "../../components/employees/EmployeeFormModal";
import ChangePasswordModal from "../../components/employees/ChangePasswordModal";
import Loader from "../../components/common/Loader";
import EmptyState from "../../components/common/EmptyState";

const EmployeeManagementPage = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [passModalOpen, setPassModalOpen] = useState(false);
  const [editingEmployee, setEditingEmployee] = useState(null);

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const data = await EmployeeService.listEmployees();
      setEmployees(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleCreate = () => {
      setEditingEmployee(null);
      setModalOpen(true);
  };

  const handleAction = async (action, employee) => {
      if (action === 'edit') {
          setEditingEmployee(employee);
          setModalOpen(true);
      } else if (action === 'delete') {
          if (window.confirm("Are you sure you want to delete " + employee.fullName + "?")) {
              await EmployeeService.deleteEmployee(employee.id);
              fetchEmployees();
          }
      } else if (action === 'block' || action === 'unblock') {
          await EmployeeService.setEmployeeBlocked(employee.id, action === 'block');
          fetchEmployees();
      } else if (action === 'change-password') {
          setEditingEmployee(employee);
          setPassModalOpen(true);
      }
  };

  const handlePasswordSubmit = async (newPassword) => {
      try {
          await EmployeeService.changeEmployeePassword(editingEmployee.id, { newPassword });
          setPassModalOpen(false);
          alert("Password updated successfully");
      } catch (e) {
          alert("Failed to update password");
      }
  };

  const handleSubmit = async (data) => {
      try {
          if (editingEmployee) {
              await EmployeeService.updateEmployee(editingEmployee.id, data);
          } else {
              await EmployeeService.createEmployee(data);
          }
          setModalOpen(false);
          fetchEmployees();
      } catch (e) {
          alert("Error saving employee");
      }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>Employee Management</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreate}>
            Add Employee
        </Button>
      </Box>
      
      {loading ? (
        <Loader />
      ) : employees.length === 0 ? (
        <EmptyState message="No employees found" />
      ) : (
        <EmployeeTable employees={employees} onAction={handleAction} />
      )}

      <EmployeeFormModal 
        open={modalOpen} 
        onClose={() => setModalOpen(false)} 
        onSubmit={handleSubmit}
        initialData={editingEmployee}
      />

      {passModalOpen && (
        <ChangePasswordModal 
            open={passModalOpen}
            onClose={() => setPassModalOpen(false)}
            onSubmit={handlePasswordSubmit}
            employeeName={editingEmployee?.fullName}
        />
      )}
    </Box>
  );
};

export default EmployeeManagementPage;
